import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'

export default function useNominationsList() {
  const items = ref([])
  const loading = ref(false)
  const zoneId = ref(null)
  const currentPage = ref(1)
  const lastPage = ref(1)
  const total = ref(0)

  async function fetch() {
    loading.value = true
    try {
      const params = { page: currentPage.value }
      if (zoneId.value != null) params.zone_id = zoneId.value
      const res = await draftApi.availableForNominations(params)
      items.value = res.data.data != null ? res.data.data : []
      const meta = res.data.meta != null ? res.data.meta : {}
      currentPage.value = meta.current_page != null ? meta.current_page : 1
      lastPage.value = meta.last_page != null ? meta.last_page : 1
      total.value = meta.total != null ? meta.total : 0
    } catch (_err) {
      // ошибки обрабатываются глобально через http.js interceptor
    } finally {
      loading.value = false
    }
  }

  function setZone(id) {
    zoneId.value = id !== '' && id != null ? Number(id) : null
    currentPage.value = 1
  }

  function setPage(page) {
    currentPage.value = page
  }

  return { items, loading, zoneId, currentPage, lastPage, total, fetch, setZone, setPage }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useNominationsList.js